import wreathVid from "../../../../src/images/paint-globs/wreath.mp4";
import globVid from "../../../../src/images/paint-globs/blob-paint.mp4";
import * as React from 'react';
export default {
  wreathVid,
  globVid,
  React
};